<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="24"
    viewBox="0 96 960 960"
    width="24"
    fill="currentColor"
  >
    <path d="M286 940q-15-15-15-35.5t15-35.5l293-293-294-294q-14-14-14-35t15-36q15-15 35.5-15t35.5 15l336 337q6 6 8.5 13t2.5 15q0 8-2.5 15t-8.5 13L356 941q-14 14-34.5 14T286 940Z" />
  </svg>
</template>

<script>
  export default {
    name: 'Forward'
  }
</script>
